const mutations = {
  RESET(state: UserStateObj) {
    state.active = {};
    state.list = [];
  },
  SET_ACTIVE(state: UserStateObj, partners: Profile) {
    state.active = partners;
  },
  USERS_UPDATE(state: UserStateObj, partners: Profile[]) {
    state.list = partners;
  }
};

export default mutations;
